import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
    return (
        <div
            data-testid="page-not-found"
            className="flex min-h-[70vh] flex-col items-center justify-center px-6 py-24 text-center"
        >
            <span className="text-xs font-semibold uppercase tracking-[0.25em] text-brand-orange">
                Erreur 404
            </span>
            <h1 className="mt-6 font-display text-5xl sm:text-6xl leading-[1.02] tracking-tightest">
                Page <em className="italic text-brand-smoke">introuvable</em>.
            </h1>
            <p className="mt-6 max-w-md text-brand-ink/70">
                La page que vous cherchez n'existe pas ou a été déplacée. Retournons à l'accueil.
            </p>
            <Link
                to="/"
                data-testid="not-found-back-home"
                className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-orange px-6 py-3 text-sm font-semibold text-white hover:bg-[#d9772c]"
            >
                <ArrowLeft className="h-4 w-4" /> Retour à l'accueil
            </Link>
        </div>
    );
}
